import * as Yup from 'yup';
import contratoFormModel from './contratoFormModel';

const {
  formField: { name, typeContract, content },
} = contratoFormModel;

export default [
  Yup.object().shape({
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),
    [typeContract.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined)
      .required(typeContract.requiredErrorMsg),
    [content.name]: Yup.string().required(`${content.requiredErrorMsg}`),
  }),
];
